import React, { useEffect, useState } from 'react';
import { Link, useHistory } from "react-router-dom"
import moment from 'moment';
import SeoPageLayout from './layout/SeoPageLayout';
import { api_call } from './helpers/untils';
import {
    FormControl, InputLabel, Select, MenuItem, Button, TextField, Grid, Typography, Box, Modal, Snackbar, makeStyles, Divider
} from '@material-ui/core';
import { Stack } from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import { Helmet } from "react-helmet-async";

const placeholderUrl = "/images/placeholder.png"

export default function BlogSite() {
    useEffect(() => {
        window.location.href = "https://moovetrax.com/blog"
    }, []);

    // const [blogList, setBlogList] = useState([]);
    // const [apiLoading, setApiLoading] = useState(false);
    // const linkOuter = true; //

    // const loadPageData = async () => {
    //     const url = `/api/blog/public-blog-list`;
    //     setApiLoading(true);
    //     let response = await api_call(url);
    //     if (response.ok) {
    //         setApiLoading(false);
    //         const apiRes = await response.json()
    //         setBlogList(apiRes.blogList || [])
    //     }
    // }

    // useEffect(() => {
    //     loadPageData();
    // }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <meta http-equiv="refresh" content="0;url=https://moovetrax.com/blog" />
            </Helmet>

            {/* <SeoPageLayout
                title="MooveTrax Blog | Contactless Automation for Car Rental"
                description="Insights, tips, and updates from MooveTrax on fleet tracking, mobility tech, logistics, and smarter transportation solutions for modern businesses"
                keywords="Turo GPS, Turo tracker, gps tracker, movetracks, movetrack, movetrax, moovetrack, moovetrax"
                linkOuter={linkOuter}
            >
                <React.Fragment>
                    <div className="blog-list-container" style={{ minHeight: '40vh' }}>
                        {
                            (apiLoading) ? (
                                <>
                                    <section style={{ paddingTop: '4rem' }}>
                                        <Stack direction={`column`} justifyContent={`center`} alignItems={`center`} spacing={1}>
                                            <div className="loading-text">Loading...</div>
                                        </Stack>
                                    </section>
                                </>
                            ) : (
                                <div className="blog-list">
                                    <Grid container spacing={4}>
                                        {
                                            blogList.map((item) => {
                                                return (
                                                    <Grid item xs={12} sm={6} md={4} xl={4} key={item.id}>
                                                        <div className="blog-item-container">
                                                            <Link to={`/article/${item.slug}`} target={linkOuter ? "_blank" : "_self"}>
                                                                <div className="post-prev-img">
                                                                    <img src={item.thumbnail || placeholderUrl} alt={item.subject} className="gb-blur-image" />
                                                                </div>
                                                                <div className="post-detail-box">
                                                                    <h3 className="post-title">{item.subject}</h3>
                                                                    <p className="post-date">{`${moment(item.createdAt).format('LLL')}, ${item.blogger_name ?? ''}`}</p>
                                                                    <div className="post-category-box">
                                                                        <p className="post-category">{`${item.category_name ?? ''}`}</p>
                                                                    </div>
                                                                    <div className="read-more-block">
                                                                        <div className="read-more-btn">
                                                                            <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                                                                                <span>Read more</span>
                                                                                <EastIcon />
                                                                            </Stack>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                </div>
                            )
                        }
                    </div>
                </React.Fragment>
            </SeoPageLayout> */}
        </>
    )
}
